import { Injectable } from '@angular/core';
import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { App } from '@df/core/app';
import { CookiesService } from '@df/core/service/cookies';
import { COOKIE_ID } from '@df/core/service/multisite';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { ICmsModalService } from '@icms/client/assets/modal/icms-modal.service';
import { NMultisiteModal } from '../modal/multisite-modal.interfaces';
import { US_INFO_MODAL_NAME } from './us-info-modal.component';

@Injectable({
    providedIn: 'root'
})
export class UsInfoModalInitiatorService extends AbstractDfModalInitiatorService<NMultisiteModal.IInitiatorData> {
    constructor(
        cmsModalService: ICmsModalService,
        protected override app: App,
        private localStorageService: LocalStorageService,
        private cookieService: CookiesService
    ) {
        super(cmsModalService, app);
    }

    listen(cb: () => void): Promise<void> {
        return new Promise(resolve => {
            if (this.canShow()) {
                // temporary, so better to keep in same place
                if(this.cookieService.get(COOKIE_ID) === 'us'){
                    this.cookieService.set(COOKIE_ID, 'uk')
                }
                cb();
            }
            resolve();
        });
    }

    canShow() {
        // already closed
        if (this.localStorageService.get(US_INFO_MODAL_NAME)) {
            return false;
        }
        const usredirQueryParam = new URLSearchParams(window.location.search).get('usredir');

        return usredirQueryParam === '1';
    }
}
